import { render } from "./CollectPartnerships.vue?vue&type=template&id=6aff4bee&scoped=true&ts=true"
import script from "./CollectPartnerships.vue?vue&type=script&lang=ts"
export * from "./CollectPartnerships.vue?vue&type=script&lang=ts"

import "./CollectPartnerships.vue?vue&type=style&index=0&id=6aff4bee&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aff4bee"]])

export default __exports__